export const IWeekAvailability = {
  mon: [{ start: '09:00', end: '20:00', 'cut-off': '20:00' }],
  tue: [],
  wed: [],
  thu: [],
  fri: [],
  sat: [],
  sun: [],
}

export const IAvailability = {
  id: 2,
  name: 'Delivery Avl',
  availability: IWeekAvailability,
  is_archive: false,
  created_at: '2023-10-06T17:25:11.829Z',
  updated_at: '2023-10-18T09:07:46.806Z',
  archived_at: null,
  is_active: false,
  from_date: null,
  to_date: '2020-01-01T00:00:00.000Z',
  last_user_id: 32,
}

export const IAvailabilityUpsertArgs = {
  id: 2,
  name: 'Delivery Avl',
  availability: IWeekAvailability,
  is_active: false,
  from_date: '',
  to_date: '2020-01-01',
}
